import { useState, useEffect, useCallback } from 'react';
import type { Chiffrage } from '../types';
import { fetchChiffrages } from '../services/api';

interface UseChiffragesOptions {
    autoRefreshInterval?: number; // en ms
}

export function useChiffrages(options: UseChiffragesOptions = {}) {
    const { autoRefreshInterval = 10000 } = options;

    const [chiffrages, setChiffrages] = useState<Chiffrage[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [lastRefresh, setLastRefresh] = useState<Date>(new Date());

    // Filtres
    const [filterUnivers, setFilterUnivers] = useState<string>('Tous');
    const [filterStatut, setFilterStatut] = useState<string>('Tous');
    const [searchQuery, setSearchQuery] = useState<string>('');

    const refresh = useCallback(async () => {
        try {
            setError(null);
            const data = await fetchChiffrages({
                univers: filterUnivers,
                statut: filterStatut,
                search: searchQuery,
            });
            setChiffrages(data);
            setLastRefresh(new Date());
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Erreur inconnue');
        } finally {
            setLoading(false);
        }
    }, [filterUnivers, filterStatut, searchQuery]);

    // Chargement initial et refresh automatique
    useEffect(() => {
        refresh();

        const interval = setInterval(refresh, autoRefreshInterval);
        return () => clearInterval(interval);
    }, [refresh, autoRefreshInterval]);

    return {
        chiffrages,
        loading,
        error,
        lastRefresh,
        refresh,
        filterUnivers,
        setFilterUnivers,
        filterStatut,
        setFilterStatut,
        searchQuery,
        setSearchQuery,
    };
}
